import React from "react";

const Vision = () => {
  return (
    <div className="bg-gray-900 text-white py-10 sm:py-20 lg:py-20">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-3 sm:mb-4">
            Vision
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-4 sm:mb-6">
            Shaping Africa&apos;s <em className="text-gray-200">AI Future</em>
          </h2>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <div>
            <div className="space-y-6 sm:space-y-8 text-sm sm:text-base md:text-lg font-light leading-relaxed text-gray-200">
              <p>
                We envision a future where African professionals and enterprises lead global AI innovation,
                using technology to solve local challenges while competing confidently on the world stage.
              </p>

              <p className="text-gray-300">
                Through{" "}
                <span className="text-white font-medium">practical training</span> and{" "}
                <span className="text-white font-medium">custom solutions</span>, we are helping to shape a
                generation of AI-powered leaders who understand both the opportunity and the responsibility
                that come with this transformative technology.
              </p>
            </div>
          </div>

          {/* Circular Visual */}
          <div className="flex justify-center md:justify-end">
            <div className="inline-block">
              <div className="w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 border border-gray-700 rounded-full flex items-center justify-center mb-6 sm:mb-8">
                <div className="w-36 h-36 sm:w-44 sm:h-44 lg:w-48 lg:h-48 border border-gray-600 rounded-full flex items-center justify-center">
                  <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 border border-gray-500 rounded-full flex items-center justify-center">
                    <div className="text-center">
                      <p className="text-2xl sm:text-3xl font-thin mb-1 sm:mb-2">AI</p>
                      <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-gray-400">
                        Leadership
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
